import { Stack, Typography } from "@mui/material"
import type { FC, ReactNode } from "react"
import SSPaper from "app/components/SSPaper"

type Props = {
  children: ReactNode
}

export const LoginLayoutBox: FC<Props> = (props) => {
  return (
    <Stack sx={{ px: 4, pt: 8 }} direction={"row"} justifyContent={"center"}>
      <Stack spacing={2} sx={{ width: "100%", maxWidth: 360 }}>
        <SSPaper sx={{ borderRadius: 3 }}>
          <Stack
            spacing={4}
            sx={{
              px: 4,
              pt: 4,
              pb: 5,
              width: "100%",
            }}
          >
            {props.children}
          </Stack>
        </SSPaper>
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          {`© ${new Date().getFullYear()} ShiftSmart`}
        </Typography>
      </Stack>
    </Stack>
  )
}
